<template>
    <div class="error-page">
        <!-- On HTTP 503 we can not lazy load the componen -->
        <http-errors-503 v-if="error.statusCode === 503"
                         v-bind:error="error" />
        <component v-else-if="errorComponent.name"
                   v-bind:is="errorComponent"
                   v-bind:error="error"
                   v-bind:img-url="'https://media.zooingvar.net/images/zooingvar-parrot-symbol.svg'" />
        <http-errors-000 v-else
                         v-bind:error="error"
                         v-bind:img-url="'https://media.zooingvar.net/images/zooingvar-parrot-symbol.svg'" />
        <v-row>
            <v-col cols="12">
                <v-btn v-bind:to="localePath('home')"
                       size="large"
                       color="info"
                       variant="flat"
                       v-on:click="handleError">
                    {{$t('$pipeline.app.general.home-btn.text')}}
                </v-btn>
                <v-btn v-if="error.data?.referer"
                       size="x-large"
                       color="info"
                       variant="flat"
                       v-on:click="handleError">
                    BACK
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script setup lang="ts">
    import type { NuxtError } from '#app';

    const localePath = useLocalePath();

    const {
        $client,
        $i18n,
        $translations
    } = useNuxtApp();

    const {
        settings
    } = storeToRefs($client);

    // PROPS
    const props = defineProps({
        error: Object as () => NuxtError
    });

    await callOnce(async () => await $translations('$pipeline.app.general.home-btn.text'));

    const handleError = () => {
        clearError({ redirect: props.error?.data?.referer ?? `/${$i18n.locale.value}` });
    }

    var name = computed(() => `http-errors-${props.error.statusCode}`);
    const errorComponent = resolveComponent(name.value);

    onMounted(() => {
        useHead({
            htmlAttrs: {
                //lang: page.value?.culture || $i18n.locale.value
            },
            title: `HTTP ${props.error.statusCode}`
        });

        useSeoMeta({
            title: `HTTP ${props.error.statusCode}`
        });
    });
</script>

<style scoped>
    .error-page {
        text-align: center;
        margin: 50px auto;
    }
</style>
